import BowlingSummary from "./BowlingSummary";
export default BowlingSummary;
